import { render, staticRenderFns } from "./InterBankTransfer.vue?vue&type=template&id=818aada6&scoped=true&"
import script from "./InterBankTransfer.vue?vue&type=script&lang=js&"
export * from "./InterBankTransfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "818aada6",
  null
  
)

export default component.exports